export enum IpMode {
  IPv4 = 'IPv4',
  IPv6 = 'IPv6',
}
